import Vue from 'vue';
import gaService from './ga.service';

export default {
  async openSession() {
    gaService.send('games', 'toto', 'toto');
    return (await Vue.http.post('/api/toto/session/open', { })).data;
  },
//   async closeSession() {
//     return (await Vue.http.post('/api/toto/session/close')).data;
//   },
//   async getTotoBet(bkBetId) {
//     return (await Vue.http.get(`/api/toto/bets/${bkBetId}`)).data;
//   },
  async getTotoBets(balanceId, date, take, skip, isSettled) {
    return (await Vue.http.post('/api/toto/bets', { balanceId, date, take, skip, isSettled })).data;
  },

}



// WEBPACK FOOTER //
// ./_common/services/toto.service.js